import React from "react";
import Header from "../components/header/Header";
import HeroSection from "../components/heroSection/HeroSection";
import FeatureHighlights from "../components/featureHighlights/FeatureHighlights";
import EssentialFeatures from "../components/EssentialFeatures/EssentialFeatures";
import ReviewsSection from "../components/ReviewsSection/ReviewsSection";
import Footer from "../components/footer/Footer";
import PromoBanner from "../components/footer/component/PromoBanner";

export default function MainPage() {
  return (
    <>
      <div className="mainpage-container" id="home">
        <Header />
        <HeroSection />
        <FeatureHighlights />
        <EssentialFeatures />
        <ReviewsSection />
        <div className="container mx-auto my-[40px] block md:hidden">
          <PromoBanner />
        </div>
      </div>
      <Footer />
    </>
  );
}
